import { InjectionToken } from '@angular/core';

import { BaseDialog } from './components';

export const DIALOG_DATA: InjectionToken<unknown> = new InjectionToken<unknown>(
  'DIALOG_DATA'
);

// Where the overlay docks. 'right' turns the dialog into a side drawer.
export type DialogPosition = 'center' | 'right';

export interface DialogConfig<T = unknown, D = BaseDialog> {
  data?: T; // Dialog data
  redirect?: boolean; // Redirect to login page
  config?: D; // Dialog configuration
  dataCy?: string; // Data-cy attribute
  anchorToBottom?: boolean; // Bottom sheet on mobile and tablet
  position?: DialogPosition; // Defaults to the centred strategy
  panelClass?: string; // Extra class on the CDK overlay pane
  blockScroll?: boolean; // Defaults to true; false leaves the page scrollable
}
